import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-circuits',
  templateUrl: './circuits.component.html',
  styleUrls: ['./circuits.component.scss']
})
export class CircuitsComponent implements OnInit {

  userRoutes = JSON.parse(localStorage.getItem('userRoutes'));
  userRoutesFiltered = JSON.parse(localStorage.getItem('userRoutes'));
  isLoading: boolean = true;
  deleteModal: boolean = false;

  constructor(private apiService: ApiService, private router: Router, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.apiService.getRoutes().subscribe(
      data => {
        this.userRoutes = JSON.parse(localStorage.getItem('userRoutes'));
        this.userRoutesFiltered = this.userRoutes;
        this.isLoading = false;
      },
      err => {
        console.log(err);
      }
    );
  }

  createNewRoute() {
    localStorage.removeItem('currentRouteId');
    this.router.navigate(['/create-circuit-1']);
  }

  onEdit(id) {
    localStorage.setItem('currentRouteId', id);
    this.router.navigate(['/create-circuit-1']);
  }

  onPublish(id) {
    this.isLoading = true;
    let route = JSON.parse(localStorage.getItem('userRoutes')).find(el => el.id === id);
    this.apiService.addRoute(route.lang, route.title, {route_id: route.id, etat: '2'}).subscribe(
      data => {
        this.reloadRoutes('Parcours publié');
      },
      err => {
        console.log(err);
      }
    );
  }

  onDraft(id) {
    this.isLoading = true;
    let route = JSON.parse(localStorage.getItem('userRoutes')).find(el => el.id === id);
    this.apiService.addRoute(route.lang, route.title, {route_id: route.id, etat: '1'}).subscribe(
      data => {
        this.reloadRoutes('Parcours dépublié');
      },
      err => {
        console.log(err);
      }
    );
  }

  onDelete(id) {
    if(window.confirm('Êtes-vous sûr de vouloir supprimer ce parcours ?\nCette action est irréversible.')){
      this.isLoading = true;
      let route = JSON.parse(localStorage.getItem('userRoutes')).find(el => el.id === id);
      this.apiService.addRoute(route.lang, route.title, {route_id: route.id, etat: '0'}).subscribe(
        data => {
          this.reloadRoutes('Parcous supprimé');
        },
        err => {
          console.log(err);
        }
      );
    }
  }

  reloadRoutes(toaster) {
    this.apiService.getRoutes().subscribe(
      data => {
        this.userRoutes = JSON.parse(localStorage.getItem('userRoutes'));
        this.userRoutesFiltered = this.userRoutes;
        this.isLoading = false;
        this.toastr.success(toaster);
      },
      err => {
        console.log(err);
      }
    );
  }

  onSearchChange(searchValue: string) {
    if (searchValue) {
      this.userRoutesFiltered = this.userRoutes.filter(el => el.title.toLowerCase().startsWith(searchValue.toLowerCase()));
    } else {
      this.userRoutesFiltered = this.userRoutes;
    }
  }

}
